import React from 'react'
import styled from 'styled-components'

const NextButton = ({type, title, onClick, setLoading}) => {
    const next = () => {
        onClick(prev => prev + 1);
    setLoading(prev => !prev)
    }

    const prev = () => {
        onClick(prev => prev - 1);
        setLoading(prev => !prev)
    }
  return (
    <NextButton.Wrapper type={type} onClick={() =>type ==="Next"?  next() : prev()}>{title || "Next"}</NextButton.Wrapper>
  )
}

NextButton.Wrapper = styled.button`
border-radius: 1rem;
margin: 0 2px;
color: ${props => props.type === "Prev" ? "pink": "white"};
font-size: 1.4rem;
font:bold 1.4rem monospace;
text-transform: capitalize;
width:8rem;
background-color:${props => props.type ==="Prev" ? "white": "pink" };
height: 4rem;
box-shadow: ${props => props.type ==="Next" ? "5px 5px 10px 2px rgba(0, 0, 0, 0.5);" : "inset 3px 3px rgba(0, 0, 0, 0.3)"};

`
export default NextButton